<template lang="pug">
div
  v-row
    v-col(:cols="toDisplayDeliverySummary ? 7 : 12")
      v-card.pa-6.mt-4.round-xl(outlined)
        div.d-flex.align-center
          div
            div.d-flex.align-center
              v-icon(size="24" color="success500") $yzi-check-circle-solid
              div.text-md.font-semibold.neutral700--text.ml-2 Campaign name
            ul.mt-5
              li.text-md.neutral700--text.ml-2 {{ storedOffer.name }}
          v-spacer
          y-button(label="Edit" size="sm" outlined @click="goToSetOffers")

      v-card.pa-6.mt-4.round-xl(outlined)
        div.d-flex.align-center
          div
            div.d-flex.align-center
              v-icon(v-if="storedOffer.redeem_method" size="24" color="success500") $yzi-check-circle-solid
              v-icon(v-else size="24" color="neutral500") $yzi-x-circle
              div.text-md.font-semibold.neutral700--text.ml-2 How to redeem
            ul.mt-5(v-if="storedOffer.redeem_method")
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.redeem_method === 'show_message'") Redeem show message at counter
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.redeem_method === 'general_code'") Redeem general coupon code
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.redeem_method === 'unique_code'") Redeem unique coupon code
          v-spacer
          y-button(:label="storedOffer.redeem_method ? 'Edit' : 'Set now'" size="sm" outlined @click="goToSetOffers")

      template(v-if="marketingSetting.plan === 'standalone'")
        connect-to-checkout
      template(v-else)
        v-card.pa-6.mt-4.round-xl(outlined)
          div.d-flex.align-center
            div
              div.d-flex.align-center
                v-icon(v-if="storedOffer.hasOwnProperty('upon_any_purchase')" size="24" color="success500") $yzi-check-circle-solid
                v-icon(v-else size="24" color="neutral500") $yzi-x-circle
                div.text-md.font-semibold.neutral700--text.ml-2 Applies to
              ul.mt-5(v-if="storedOffer.hasOwnProperty('upon_any_purchase')")
                li.text-md.neutral700--text.ml-2(v-if="storedOffer.upon_any_purchase") All inventory & services
                li.text-md.neutral700--text.ml-2(v-else) Specific inventory and services ({{ storedOffer.purchase_products.length }})
            v-spacer
            y-button(:label="storedOffer.hasOwnProperty('upon_any_purchase') ? 'Edit' : 'Set now'" size="sm" outlined @click="goToSetOffers")
          template(v-if="storedOffer.hasOwnProperty('upon_any_purchase') && !storedOffer.upon_any_purchase")
            inventory-services-selection(v-model="storedOffer.purchase_products" readonly)

      v-card.pa-6.mt-4.round-xl(outlined)
        div.d-flex.align-center
          div
            div.d-flex.align-center
              v-icon(v-if="storedOffer.reward_type" size="24" color="success500") $yzi-check-circle-solid
              v-icon(v-else size="24" color="neutral500") $yzi-x-circle
              div.text-md.font-semibold.neutral700--text.ml-2 Offers reward
            ul.mt-5(v-if="storedOffer.reward_type")
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.reward_type === 'discount_percentage'") {{ storedOffer.discount_percentage }}% percentage discount
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.reward_type === 'discount_amount'") Discount {{ storedOffer.discount_amount | displayPrice($currency) }}
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.reward_type === 'free_item' && storedOffer.free_item_type === 'visit'") Free visit
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.reward_type === 'free_item' && storedOffer.free_item_type === 'other'") Free item: {{ storedOffer.free_item_name }}
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.reward_type === 'free_item' && storedOffer.free_item_type === 'product'") Free:
          v-spacer
          y-button(:label="storedOffer.reward_type ? 'Edit' : 'Set now'" size="sm" outlined @click="goToSetOffers")
        template(v-if="storedOffer.reward_type === 'free_item' && storedOffer.free_item_type === 'product'")
          inventory-services-selection(v-model="storedOffer.free_products" readonly)

      v-card.pa-6.mt-4.round-xl(outlined)
        div.d-flex.align-center
          div
            div.d-flex.align-center
              v-icon(v-if="storedOffer.usage_limit_type" size="24" color="success500") $yzi-check-circle-solid
              v-icon(v-else size="24" color="neutral500") $yzi-x-circle
              div.text-md.font-semibold.neutral700--text.ml-2 Offers usage limit
            ul.mt-5(v-if="storedOffer.usage_limit_type")
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.usage_limit_type === 'quantity'") Limit usage to {{ storedOffer.usage_limit }} times
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.usage_limit_type === 'one_each'") Limit to one use per customer
          v-spacer
          y-button(:label="storedOffer.usage_limit_type ? 'Edit' : 'Set now'" size="sm" outlined @click="goToSetOffers")

      v-card.pa-6.mt-4.round-xl(outlined)
        div.d-flex.align-center
          div
            div.d-flex.align-center
              v-icon(v-if="storedOffer.usage_limit_type" size="24" color="success500") $yzi-check-circle-solid
              v-icon(v-else size="24" color="neutral500") $yzi-x-circle
              div.text-md.font-semibold.neutral700--text.ml-2 Active date and time
            ul.mt-5
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.is_start_immediately") Starts immediately after this offer is created
              li.text-md.neutral700--text.ml-2(v-else-if="storedOffer.start_at") Starts on {{ $options.filters.humanizeDate(storedOffer.start_at)}}
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.end_at") Ends on {{ $options.filters.humanizeDate(storedOffer.end_at)}}
              li.text-md.neutral700--text.ml-2(v-else) No end date
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.active_all_day") Eligible to be use all day
              li.text-md.neutral700--text.ml-2(v-else) Eligible to be use from {{ $options.filters.displayTime2(storedOffer.active_from) }} to {{ $options.filters.displayTime2(storedOffer.active_until) }}
          v-spacer
          y-button(:label="storedOffer.usage_limit_type ? 'Edit' : 'Set now'" size="sm" outlined @click="goToSetOffers")

      v-card.pa-6.mt-4.round-xl(outlined)
        div.d-flex.align-center
          div
            div.d-flex.align-center
              v-icon(v-if="storedOffer.hasOwnProperty('thankyou_msg_enabled')" size="24" color="success500") $yzi-check-circle-solid
              v-icon(v-else size="24" color="neutral500") $yzi-x-circle
              div.text-md.font-semibold.neutral700--text.ml-2 Thank you message
            ul.mt-5
              li.text-md.neutral700--text.ml-2(v-if="storedOffer.thankyou_msg_enabled") Enabled
              li.text-md.neutral700--text.ml-2(v-else) Disabled
          v-spacer
          y-button(:label="storedOffer.hasOwnProperty('thankyou_msg_enabled') ? 'Edit' : 'Set now'" size="sm" outlined @click="goToSetThankyouMessage")
      
      v-card.pa-6.mt-4.round-xl(outlined)
        div.d-flex.align-center
          div
            div.d-flex.align-center
              v-icon(v-if="storedOffer.to_all_customers || storedOffer.to_all_loyalty_members || storedOffer.groups.length || storedOffer.customers.length" size="24" color="success500") $yzi-check-circle-solid
              v-icon(v-else size="24" color="neutral500") $yzi-x-circle
              div.text-md.font-semibold.neutral700--text.ml-2 Audience eligibility
          v-spacer
          y-button(:label="(storedOffer.to_all_customers || storedOffer.to_all_loyalty_members || storedOffer.groups.length || storedOffer.customers.length) ? 'Edit' : 'Set now'" size="sm" outlined @click="gotToSetAudience")
        ul.mt-5(v-if="storedOffer.to_all_customers")
          li.text-md.neutral700--text.ml-2 Everyone
        ul(v-if="storedOffer.to_all_loyalty_members")
          li.text-md.neutral700--text.ml-2 Loyalty members
        ul(v-if="storedOffer.groups.length")
          li.text-md.neutral700--text.ml-2 Specific group of customers:
        template(v-if="storedOffer.groups.length")
          segment-selection.mb-5(v-model="storedOffer.groups" :parent-offer="storedOffer" readonly)
        ul(v-if="storedOffer.customers.length")
          li.text-md.neutral700--text.ml-2 Specific customers:
        template(v-if="storedOffer.customers.length")
          customer-list(:offer="storedOffer")

      v-card.pa-6.mt-4.round-xl(outlined)
        div.d-flex.align-center
          div
            div.d-flex.align-center
              v-icon(v-if="storedBlasts.filter(f => f.type === 'offer').length" size="24" color="success500") $yzi-check-circle-solid
              v-icon(v-else size="24" color="neutral500") $yzi-x-circle
              div.text-md.font-semibold.neutral700--text.ml-2 Offer deliverance
          v-spacer
          y-button(:label="storedBlasts.filter(f => f.type === 'offer').length ? 'Edit' : 'Set now'" size="sm" outlined @click="goToSetDeliveryMethods")
        template(v-if="storedBlasts.filter(f => f.type === 'offer').length")
          v-simple-table.mt-5
            thead
              tr(style="background-color: var(--v-neutral200)")
                th(style="width: 25%;") deliverance
                th(style="width: 50%;") blast frequency
                th status
            tbody
              template(v-for="(offer, index) in offersDeliverance")
                tr(:key="`off-${index}`")
                  td.py-3
                    div.d-flex.align-center
                      v-avatar.mr-2(size="8" :color="offer.data ? 'success500' : 'blue500'")
                      div.text-sm.font-semibold.neutral700--text {{ getText(offer.method) }}
                  td.py-3
                    div.d-flex.align-center
                      template(v-if="offer.data")
                        div.text-xs.neutral700--text(v-if="offer.data.send_cue === 'offer_activated'") Immediately after offer created
                        div.text-xs.neutral700--text(v-if="offer.data.send_cue === 'scheduled'") Blast later on {{ getScheduleText(offer.data.schedules) }}
                      template(v-else)
                        div.text-xs.neutral700--text Not set yet
                  td.py-3
                    div.d-flex.align-center
                      template(v-if="offer.data && offer.data.enabled")
                        v-chip.round-md.success500--text(color="#EEFCE9" label small) Active
                      template(v-else)
                        v-chip.round-md.danger500--text(color="#FFEBEB" label small) Inactive
          v-divider

      v-card.pa-6.mt-4.round-xl(v-if="storedOffer.thankyou_msg_enabled" outlined)
        div.d-flex.align-center
          div
            div.d-flex.align-center
              v-icon(v-if="storedBlasts.filter(f => f.type === 'thank_you').length" size="24" color="success500") $yzi-check-circle-solid
              v-icon(v-else size="24" color="neutral500") $yzi-x-circle
              div.text-md.font-semibold.neutral700--text.ml-2 Thank you message deliverance
          v-spacer
          y-button(:label="storedBlasts.filter(f => f.type === 'thank_you').length ? 'Edit' : 'Set now'" size="sm" outlined @click="goToSetThankyouMessage")
        template(v-if="storedBlasts.filter(f => f.type === 'thank_you').length")
          v-simple-table.mt-5
            thead
              tr(style="background-color: var(--v-neutral200)")
                th(style="width: 25%;") deliverance
                th(style="width: 50%;") blast frequency
                th status
            tbody
              template(v-for="(thank, index) in thankYouMessage")
                tr(:key="`thx-${index}`")
                  td.py-3
                    div.d-flex.align-center
                      v-avatar.mr-2(size="8" :color="thank.data ? 'success500' : 'blue500'")
                      div.text-sm.font-semibold.neutral700--text {{ getText(thank.method) }}
                  td.py-3
                    div.d-flex.align-center
                      template(v-if="thank.data")
                        div.text-xs.neutral700--text {{ getSendToText(thank.data) }}
                          span.font-medium.ml-1(v-if="thank.data.send_to !== 'all'") {{ getSendCueText(thank.data) }}
                      template(v-else)
                        div.text-xs.neutral700--text Not set yet
                  td.py-3
                    div.d-flex.align-center
                      template(v-if="thank.data && thank.data.enabled")
                        v-chip.round-md.success500--text(color="#EEFCE9" label small) Active
                      template(v-else)
                        v-chip.round-md.danger500--text(color="#FFEBEB" label small) Inactive
          v-divider

    v-col(v-if="toDisplayDeliverySummary" cols="5")
      offer-setup-review-sms-summary.mt-4
      offer-setup-review-email-summary.mt-4
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InventoryServicesSelection from '@/components/clinic/marketing/InventoryServicesSelection.vue'
import SegmentSelection from '@/components/clinic/marketing/SegmentSelection.vue'
import CustomerList from '@/components/clinic/marketing/CustomerList.vue'
import DatePickerField from '@/components/clinic/marketing/DatePickerField.vue'
import ConnectToCheckout from "@/components/clinic/marketing/ConnectToCheckout.vue";
import OfferSetupReviewSmsSummary from "@/components/clinic/marketing/OfferSetupReviewSmsSummary.vue";
import OfferSetupReviewEmailSummary from "@/components/clinic/marketing/OfferSetupReviewEmailSummary.vue";

export default {
  components: {
    OfferSetupReviewEmailSummary, OfferSetupReviewSmsSummary, ConnectToCheckout, InventoryServicesSelection, SegmentSelection, CustomerList, DatePickerField
  },
  data () {
    return {
      setEndAt: false,
      audienceGroups: false,
      filterCustomers: false,
      startDate: null,
      startTime: '00:00',
      endDate: null,
      endTime: '00:00',
      step: 0,
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      storedOffer: 'marketing/getOffer',
      storedBlasts: 'marketing/getBlasts',
      summary: 'marketing/getSummary',
      marketingSetting: 'marketing/getMarketingSettings'
    }),
    offersDeliverance () {
      let offers = [
        { method: 'sms', data: null },
        { method: 'whatsapp', data: null },
        { method: 'email', data: null }
      ]
      let blasts = this.storedBlasts
      if (blasts.find(f => f.method === 'sms' && f.type === 'offer')) {
        let data = blasts.find(f => f.method === 'sms' && f.type === 'offer')
        let offer = offers.find(f => f.method === 'sms')
        this.$set(offer, 'data', data)
      }
      if (blasts.find(f => f.method === 'email' && f.type === 'offer')) {
        let data = blasts.find(f => f.method === 'email' && f.type === 'offer')
        let offer = offers.find(f => f.method === 'email')
        this.$set(offer, 'data', data)
      }
      if (blasts.find(f => f.method === 'whatsapp' && f.type === 'offer')) {
        let data = blasts.find(f => f.method === 'whatsapp' && f.type === 'offer')
        let offer = offers.find(f => f.method === 'whatsapp')
        this.$set(offer, 'data', data)
      }
      return offers
    },
    thankYouMessage () {
      let thanks = [
        { method: 'sms', data: null },
        { method: 'whatsapp', data: null },
        { method: 'email', data: null }
      ]
      let blasts = this.storedBlasts
      if (blasts.find(f => f.method === 'sms' && f.type === 'thank_you')) {
        let data = blasts.find(f => f.method === 'sms' && f.type === 'thank_you')
        let thank = thanks.find(f => f.method === 'sms')
        this.$set(thank, 'data', data)
      }
      if (blasts.find(f => f.method === 'email' && f.type === 'thank_you')) {
        let data = blasts.find(f => f.method === 'email' && f.type === 'thank_you')
        let thank = thanks.find(f => f.method === 'email')
        this.$set(thank, 'data', data)
      }
      if (blasts.find(f => f.method === 'whatsapp' && f.type === 'thank_you')) {
        let data = blasts.find(f => f.method === 'whatsapp' && f.type === 'thank_you')
        let thank = thanks.find(f => f.method === 'whatsapp')
        this.$set(thank, 'data', data)
      }
      return thanks
    },
    toDisplayDeliverySummary () {
      if (this.storedBlasts.length === 0) return false
      if (this.storedOffer.thankyou_msg_enabled) {
        return this.storedBlasts.some(item => item.enabled)
      }
      return this.storedBlasts.some(item => item.enabled && item.type === 'offer')
    },
  },
  mounted () {
  },
  methods: {
    ...mapActions(['showMessage']),
    sanitizeUnusedObject (strings, arrays) {
      if (strings && strings.length) {
        strings.forEach(f => {
          if (this.offer[f]) this.offer[f] = null
        })
      }
      if (arrays && arrays.length) {
        arrays.forEach(o => {
          if (this.offer[o]) this.offer[o] = []
        })
      }
    },
    goToSetOffers () {
      this.$store.commit('marketing/setCreateOfferStep', 0)
    },
    gotToSetAudience () {
      this.$store.commit('marketing/setCreateOfferStep', 1)
    },
    goToSetDeliveryMethods () {
      this.$store.commit('marketing/setCreateOfferStep', 2)
    },
    goToSetThankyouMessage () {
      this.$store.commit('marketing/setCreateOfferStep', 3)
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      let payload = JSON.parse(JSON.stringify(this.offer))
      payload.start_at = `${this.startDate} ${this.startTime}`
      if (this.setEndAt) {
        payload.end_at = `${this.endDate} ${this.endTime}`
      }
      payload.purchase_products = this.offer.purchase_products.map(m => m.id)
      payload.free_products = this.offer.free_products.map(m => m.id)
      payload.groups = this.offer.groups.map(m => { return { id: m.id, include_later_members: m.include_later_members } })
      if (this.offer.id) {
        for (const key in payload) {
          if (payload[key] === null) {
            delete payload[key];
          }
        }
        this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}`, payload)
          .then(resp => {
            this.offer = resp.data
            this.$emit('updated', resp.data.id)
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
      } else {
        this.$axios.post(`/marketing/${this.company.slug}/offers`, payload)
          .then(resp => {
            this.offer = resp.data
            this.$emit('updated', resp.data.id)
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
      }
    },
    getText (method) {
      if (method === 'sms') return 'SMS'
      if (method === 'whatsapp') return 'WhatsApp API'
      if (method === 'email') return 'Email'
    },
    getSendToText (data) {
      let text = null
      if (data.send_to === 'redeemed_recipient') {
        text = 'Send to customer that redeemed the offer'
      } else if (data.send_to === 'all') {
        text = 'Send to everyone'
      }
      return text
    },
    getSendCueText (data) {
      let text = null
      if (data.send_cue === 'offer_redeemed') {
        text = `${data.auto_send_delay_time_value} min after redemption`
      } else if (data.send_cue === 'scheduled') {
        text = `on ${this.$options.filters.convertServerDate(data.schedules[0].scheduled_for)}`
      } else if (data.send_cue === 'offer_ended') {
        text = 'right after the campaign ended'
      }
      return text
    },
    getScheduleText (schedules) {
      let text = null
      if (schedules.length) {
        let datetimes = schedules.map(m => m.scheduled_for)
        if (datetimes.length > 2) {
          text = `${this.$options.filters.convertServerDate(datetimes[0])}, ${this.$options.filters.convertServerDate(datetimes[1])} and ${datetimes.length - 2} more`
        } else if (datetimes.length > 1) {
          text = `${this.$options.filters.convertServerDate(datetimes[0])} and ${this.$options.filters.convertServerDate(datetimes[1])}`
        } else {
          text = `${this.$options.filters.convertServerDate(datetimes[0])}`
        }
      }
      return text
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .custom-simple-table {
  .text-table-header, .v-data-table__wrapper > table > thead > tr > th {
    text-transform: unset !important;
  }
}
</style>